import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import header from './components/Header'
import footer from './components/Footer'
import moment from 'moment'


Vue.component('page-header', header)
Vue.component('page-footer', footer)
Vue.config.productionTip = false

//Facebook SDK initializing
function initFacebookSdk() {
  return new Promise(() => {
    // wait for facebook sdk to initialize before starting the vue app
    window.fbAsyncInit = function () {
      FB.init({
        appId: 1201683783978351,
        cookie: true,
        xfbml: true,
        version: 'v15.0'
      });
    };


    // load facebook sdk script
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  });
}
//End Facebook SDK initializing

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

initFacebookSdk().then(() => {console.log('Facebook Initialized')});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');





// WEBPACK FOOTER //
// ./src/main.js